import { render, staticRenderFns } from "./NavegationMenu.vue?vue&type=template&id=2f87e369"
import script from "./NavegationMenu.vue?vue&type=script&lang=js"
export * from "./NavegationMenu.vue?vue&type=script&lang=js"
import style0 from "./NavegationMenu.vue?vue&type=style&index=0&id=2f87e369&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports